<div class="d-flex flex-row fes-sort-field" style="height:100%;">
    <div>
        <ng-content></ng-content>
    </div>
    <i style="padding-left:2px;" [ngClass]="sortClass()"></i>
</div>
